import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Links({ item, className }) {
    const { links } = item;
    if (!links?.items?.length) return <p>Add links to preview</p>;

    const renderIcon = (icon) => {
        return icon ? <FontAwesomeIcon fixedWidth icon={icon} /> : null;
    };

    return (
        <ul className={`dorik-list ${className}`}>
            {links.items.map((link, indx) => (
                <li className="dorik-list--item" key={indx}>
                    <a
                        href="#"
                        target={link.target}
                        className="dorik-list--link"
                    >
                        {link.icon && (
                            <span className="dorik-list--icon">
                                {renderIcon(link.icon)}
                            </span>
                        )}
                        <span className="dorik-list--text">{link.label}</span>
                    </a>
                </li>
            ))}
        </ul>
    );
}

export default Links;
